import { render, staticRenderFns } from "./DetailsSalesOnlineBox.vue?vue&type=template&id=440522b3"
import script from "./DetailsSalesOnlineBox.vue?vue&type=script&lang=ts"
export * from "./DetailsSalesOnlineBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports